import React from "react";
//import { AUTH_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "login",
    path: `/signup`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/signup")
    ),
  },
  {
    key: "reset-password",
    path: `/reset-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login/reset-password")
    ),
  },
  {
    key: "forgot-password",
    path: `/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "home",
    path: `/home`,
    component: React.lazy(() => import("views/app-views/dashboards/home")),
  },
  {
    key: "wallet",
    path: `/wallet`,
    component: React.lazy(() => import("views/app-views/dashboards/wallet")),
  },
  {
    key: "payments",
    path: `/payments`,
    component: React.lazy(() => import("views/app-views/dashboards/payments")),
    permissions: ["Payment.View"],
  },
  {
    key: "payment-details",
    path: `/payments/:id`,
    permissions: ["Payment.View"],
    component: React.lazy(() =>
      import("views/app-views/dashboards/payments/PaymentDetails")
    ),
  },
  {
    key: "statement",
    path: `/transactions`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/transactions")
    ),
  },
  {
    key: "team",
    path: `/team`,
    component: React.lazy(() => import("views/app-views/dashboards/team")),
  },
  {
    key: "profile",
    path: `/profile`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/company-profile")
    ),
  },
  {
    key: "sender",
    path: `/sender`,
    permissions: ["Sender.View"],
    component: React.lazy(() => import("views/app-views/dashboards/sender")),
  },
  {
    key: "sender-details",
    path: `/sender/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/sender/SenderDetails")
    ),
  },
  {
    key: "beneficiaries",
    path: `/beneficiaries`,
    permissions: ["Beneficiary.View"],
    component: React.lazy(() =>
      import("views/app-views/dashboards/beneficiaries")
    ),
  },
  {
    key: "beneficiary-details",
    path: `/beneficiaries/:id`,
    permissions: ["Beneficiary.View"],
    component: React.lazy(() =>
      import("views/app-views/dashboards/beneficiaries/BeneficiaryDetails")
    ),
  },
  // {
  //   key: "kyc",
  //   path: `/kyc`,
  //   component: React.lazy(() =>
  //     import("views/app-views/dashboards/business-profile")
  //   ),
  // },
  // {
  //   key: "kyc-documents",
  //   path: `/kyc/documents`,
  //   component: React.lazy(() =>
  //     import("views/app-views/dashboards/business-profile/BusinessDocuments")
  //   ),
  // },
  // {
  //   key: "kyc-indiviuals",
  //   path: `/kyc/individuals`,
  //   component: React.lazy(() =>
  //     import("views/app-views/dashboards/business-profile/Individuals")
  //   ),
  // },
  // {
  //   key: "kyc-proof-of-address",
  //   path: `/kyc/proof-of-address`,
  //   component: React.lazy(() =>
  //     import("views/app-views/dashboards/business-profile/BusinessAddress")
  //   ),
  // },
  {
    key: "account-settings",
    path: `/account-settings`,
    component: React.lazy(() => import("views/app-views/dashboards/settings")),
  },
  {
    key: "faq",
    path: `/faq`,
    component: React.lazy(() => import("views/app-views/dashboards/faq")),
  },
  {
    key: "error-page",
    path: `/error-page`,
    component: React.lazy(() => import("views/app-views/error")),
  },
];
